module.exports = __webpack_public_path__ + "img/checkmark.39f9845.svg";